import styled from 'styled-components';
import { Image } from '@/shared/ui/image/Image';

const Container = styled.div<{
  $isView?: boolean;
}>`
  display: ${({ $isView }) => $isView ? 'flex' : 'none'};
  align-items: center;
  gap: 8px;
  width: max-content;
`;

const WarningIcon = styled(Image)<{ width?: string; height?: string }>`
  & img {
    width: ${({ width }) => width || '24px'};
    height: ${({ height }) => height || '24px'};
  }
`;

export { Container, WarningIcon };